import { get, includes } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from '../../../app/commonReducer';
import { withComponentId } from '../../../common/ComponentIdContext';
import { withComponentName } from '../../../common/ComponentNameContext';
import { TYPE_DISABLE } from '../../../common/sync-component/Const';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../../helpers/EventEmitter';
import { formatTextFloat, formatValueBillion } from '../../../helpers/Text';
import { cellNegtiveRed } from '../../../common/table/CustomCellTable';
import {
  toggleConfirmPopupDelete,
  REDUCER_NAME,
  changeTableIndexSortState,
  setSortedIds,
} from '../reducer';
import Table from '../../../common/table/Table';
import { getColorRedWhite } from './../../../helpers/Color';
import Const from './Const';
import CellHover from '../summary/CellHover';
import {
  getDataFollowKeyByDot,
  syncComponentSelector,
} from '../../../helpers/Common';
import { compose } from 'redux';
import TradingViewUrl from '../../../common/TradingViewUrl';

const getDataFromRedux = state => state[REDUCER_NAME].listSummaryTableByTicker;

class TableFun extends React.Component {
  handleDelete = (isShow, organCode) => () => {
    const { toggleConfirmPopupDelete } = this.props;

    toggleConfirmPopupDelete(isShow, organCode);
  };

  onRowClick = organCode => {
    const { listOrganizationByOrganCode, syncType } = this.props;
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      syncType: syncType,
      search: listOrganizationByOrganCode[organCode],
    });
  };

  render() {
    const {
      ids,
      isFetching,
      idHover,
      isShowDeleteIcon,
      changeTableIndexSortState,
      sortState,
      setSortedIds,
    } = this.props;

    return (
      <div className="d-flex flex-fill px-20 pb-10">
        <Table
          clickRow={this.onRowClick}
          onRowReorder={setSortedIds}
          sortState={sortState}
          onSort={changeTableIndexSortState}
          thValign="top"
          ids={ids}
          resizable={true}
          columnDraggable={true}
          rowDraggable={true}
          tdPadding={20}
          hideColumns={[]}
          isLoading={isFetching}
          getDataFromRedux={getDataFromRedux}
          idHover={idHover}
          schema={Object.keys(Const.listColumn).map((item, index) => {
            const key = Const.listColumn[item];
            const title = `watchListFundamental.listTitleTable.${item}`;
            const result = {
              key,
              title,
            };

            if (index === 0) {
              return {
                isString: true,
                thStyle: {
                  width: '10%',
                },
                ...result,
                render: (text, item) => (
                  <CellHover
                    organCode={item.organCode}
                    isShowDeleteIcon={isShowDeleteIcon}
                    handleDelete={this.handleDelete(
                      true,
                      getDataFollowKeyByDot(item, Const.ORGAN_CODE),
                    )}
                  >
                    <TradingViewUrl code={item.organCode} />
                    &nbsp;
                    {text}
                  </CellHover>
                ),
              };
            }

            if (
              includes(
                [
                  Const.listColumn.RTD11,
                  Const.listColumn.FRYQ30,
                  Const.listColumn.ISA20,
                ],
                key,
              )
            ) {
              return {
                ...result,
                render: text => {
                  const className = getColorRedWhite(text);
                  return (
                    <span className={className}>
                      {formatTextFloat(formatValueBillion(text))}
                    </span>
                  );
                },
              };
            }

            if (includes([Const.listColumn.ISA3], key)) {
              return {
                ...result,
                render: text => {
                  const className = getColorRedWhite(text);
                  return (
                    <span className={className}>
                      {formatTextFloat(formatValueBillion(text))}
                    </span>
                  );
                },
              };
            }

            if (
              includes([Const.listColumn.RTD7, Const.listColumn.RTD53], key)
            ) {
              return {
                ...result,
                render: text => {
                  const className = getColorRedWhite(text);
                  return (
                    <span className={className}>
                      {formatTextFloat(text, 0)}
                    </span>
                  );
                },
              };
            }

            if (includes([Const.listColumn.RTD14], key)) {
              return {
                ...result,
                render: text => {
                  const className = getColorRedWhite(text);
                  return (
                    <span className={className}>
                      {cellNegtiveRed(formatTextFloat(text, 0))}
                    </span>
                  );
                },
              };
            }

            return {
              ...result,
              render: text => {
                const className = getColorRedWhite(text);
                return (
                  <span className={className}>{formatTextFloat(text)}</span>
                );
              },
            };
          })}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, { componentName, componentId }) => ({
  ids:
    state[REDUCER_NAME].sortedIds || state[REDUCER_NAME].listTickerSummaryTable,
  isFetching: state[REDUCER_NAME].isFetching,
  idHover: state[REDUCER_NAME].organCodeHover,
  sortState: state[REDUCER_NAME].tableIndexSortState,
  listOrganizationByOrganCode:
    state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
  syncType: syncComponentSelector(state, componentName, componentId),
});

const mapDispatchToProps = {
  toggleConfirmPopupDelete,
  changeTableIndexSortState,
  setSortedIds,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(TableFun);
